<template>
  <div class="others" :class="{'contract':inputCard.card_type==32}">
    <!-- 下拉框 -->
    <template v-if="inputCard.card_type==31">
      <label slot="label" v-if="disabled" v-html="`${inputCard.label.content}${inputCard.label.icon_msg ? `(${inputCard.label.icon_msg})`:''}`"></label>

      <el-form-item>
        <div style="margin-bottom: 5px;">
          <el-select :disabled="disabled" :placeholder="`请选择${inputCard.label.content}一级`" v-model="form.first" :multiple="!hasSecond&&multiple" @change="changeFirst" clearable>
            <el-option v-for="item in casOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div v-if="hasSecond" style="margin-bottom: 5px;">
          <el-select :disabled="disabled" :placeholder="`请选择${inputCard.label.content}二级`" v-model="form.second" :multiple="multiple" @change="emitData" clearable>
            <el-option v-for="item in getSecondOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </el-form-item>
    </template>

     <!-- 勾选协议 -->
    <template v-if="inputCard.card_type==32">
      <el-checkbox v-model="contract" :disabled="disabled" @change="changeContract" true-label="true" false-label="false">请勾选同意</el-checkbox><a :href="link" target="_blank" >《{{ inputCard.label.content }}》</a>
    </template>
    
  </div>
</template>
<script>
import { getData } from "../../utils/utils";
export default {
  name: "others",
  components: {
 
  },
  props: {
    value: [Object,String,Number,Boolean,Array],
    inputKey: String,
    inputCard: Object,
    disabled:Boolean
  },
  watch: {
  },
  data() {
    return {
      casOptions: [
        {
          value: 'level1-1',
          label: '重大革命和历史题材',
          children: [
            { value: 'level2-1-1', label: '政治' },
            { value: 'level2-1-2', label: '军事' }
          ]
        },
        {
          value: 'level1-2',
          label: '特殊题材',
          children: [
            { value: 'level2-2-1', label: '外交' },
            { value: 'level2-2-2', label: '国家安全' }
          ]
        }
      ],
      form: {
        first: '',    //一级
        second: ''   // 二级
      },
      hasSecond: false,//是否有二级下拉
      multiple: true,//末级是否多选？
      contract:false,
      link:''
      
    };
  },
  created() {
    const fieldId = this.inputCard.options.fieldId
    const params = {fieldId}
    if (this.$route.query['loginParam']) {
      params.loginParam=this.$route.query['loginParam']
    }
    if (this.inputCard.card_type == 31) {
      this.multiple = this.inputCard.options.fieldSecType==2;
      // 获取下拉数据
      getData('/api/field/config/select', params,
        (res) => {
          if (res.code == 0 && res.data) {
            this.hasSecond = res.data[0].children.length>0
            this.casOptions = res.data
            if (this.value) {
              this.form = this.value
            }
            if (!this.multiple) {// 单选，都是单选
              this.form.first = this.form.first[0]
              this.form.second = this.hasSecond?this.form.second[0]:''
            }
            if (this.multiple&&this.hasSecond) {// 多选,有二级， 一级是单选
              this.form.first = this.form.first[0]
            }
            this.emitData()//编辑时 未修改的情况
          }
        }
      )
      
    }
    if (this.inputCard.card_type == 32) { 
      this.contract = this.value||false
      getData('/api/field/config/contract', params,
        (res) => {
          if (res.code == 0&&res.data) {
            this.link=res.data
          }
        }
      )
    }
   
  },
  computed: {
    getSecondOptions() {
      const index = this.casOptions.findIndex(item => item.value == this.form.first)
      if(index == -1) return []
      return this.casOptions[index].children
    }
  },
  methods: {
    changeFirst(val) {
      // console.log('changeFirst',val)
      this.form.second = this.multiple ? [] : ''
      this.emitData()
    },
    emitData() {
      // console.log('emitData',this.form.first,this.form.second)
      const form = {
        first:this.form.first? [this.form.first]:[],
      }
      if (this.hasSecond) {
        form.second=!this.multiple?(this.form.second?[this.form.second]:[]):this.form.second
      }
      this.$emit("change", { key:this.inputKey,value:form });
      
    },
    changeContract(value) { 
      this.$emit("change", { key:this.inputKey,value });
    }
  }
};
</script>
<style scoped>
 .others.contract {
  height: 28px;
  line-height: 40px;
 }
 .others a{
  cursor: pointer;
  color:#409EFF;
  text-decoration: none;
 }
</style>



// WEBPACK FOOTER //
// src/components/form/Others.vue